import { useEffect } from 'react';

/**
 * While `active` (a form with unsent input, a code not saved yet), closing or reloading the tab asks first. The
 * browser shows its own sentence; in-app links that leave ask through `useConfirm` at their call site.
 */
export function useLeaveGuard(active: boolean) {
  useEffect(() => {
    if (!active) return;
    const ask = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // older browsers need returnValue set to show the prompt
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', ask);
    return () => window.removeEventListener('beforeunload', ask);
  }, [active]);
}
